import { render, staticRenderFns } from "./CareHelp.vue?vue&type=template&id=7dbd4860&"
import script from "./CareHelp.vue?vue&type=script&lang=js&"
export * from "./CareHelp.vue?vue&type=script&lang=js&"
import style0 from "./CareHelp.vue?vue&type=style&index=0&id=7dbd4860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports